module.exports = __webpack_public_path__ + "img/1F1E6-1F1F9.a07a3fcb.svg";